import { Coverage } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import ChevronDownIcon from '../../../../assets/icons/ChevronDown';
import ChevronUpIcon from '../../../../assets/icons/ChevronUp';
import ExpandableList from '../../../../components/ExpandableList';
import colors from '../../../../constants/colors';
import useAnalytics from '../../../../hooks/useAnalytics';

interface Props {
  data: Coverage[];
}

const Coverages: React.FC<Props> = ({ data }: Props) => {
  const { track } = useAnalytics();
  const content = (isExpanded: boolean) => (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        p: 2,
        width: 1,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          fontSize: { mobile: 16, tablet: 18 },
          lineHeight: '24px',
          letterSpacing: { mobile: 0.3, tablet: 0.4 },
        }}
      >
        Coverages
      </Typography>
      <Stack
        sx={{
          background: 'rgba(11, 20, 33, 0.1)',
          cursor: 'pointer',
          p: 0.5,
          height: 'fit-content',
          borderRadius: 1,
        }}
      >
        {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Stack>
    </Stack>
  );
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: colors.csaaBorder,
        borderRadius: 2,
      }}
    >
      <ExpandableList
        content={content}
        id="property-coverages"
        onClick={(isOpen) =>
          track('Coverages Details Toggled', {
            event_type: 'UX Modified',
            location: 'Feature Card',
            link: 'Coverages',
            selection: isOpen ? 'Closed' : 'Opened',
          })
        }
      >
        <Stack
          spacing={1}
          sx={{
            p: 2,
            backgroundColor: colors.csaaNeutralBackground,
            borderTop: '1px solid',
            borderColor: colors.csaaBorder,
            borderBottomRightRadius: 8,
            borderBottomLeftRadius: 8,
          }}
        >
          {data?.map((item, idx) => (
            <Stack
              key={`${item.coverageDescription}-${idx}`}
              spacing={1}
              direction="row"
              justifyContent="space-between"
              sx={{
                backgroundColor: colors.csaaWhite,
                p: { mobile: 2, tablet: 3 },

                boxShadow: `inset 0px 0px 0px 1px ${colors.csaaNeutral}`,
                borderRadius: 2,
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Cabin',
                  fontKerning: 'normal',
                  fontSize: { mobile: 16, tablet: 18 },
                  lineHeight: '24px',
                  fontWeight: 700,
                  letterSpacing: { mobile: 0.3, tablet: 0.4 },
                  textAlign: 'left',
                }}
              >
                {item.coverageDescription}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Cabin',
                  fontKerning: 'normal',
                  fontSize: { mobile: 16, tablet: 18 },
                  lineHeight: '24px',
                  fontWeight: 700,
                  letterSpacing: { mobile: 0.3, tablet: 0.4 },
                  whiteSpace: 'nowrap',
                }}
              >
                {item.coverageLimit}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </ExpandableList>
    </Box>
  );
};

export default Coverages;
